// extracted by mini-css-extract-plugin
module.exports = {"root":"upload_root__vbUCn","uploadButton":"upload_uploadButton__Rr7vC flex items-center justify-center","errorInfo":"upload_errorInfo__ZN559"};